export const RANKING_LIMITS = {
  MAX_PLAYERS_PER_RANKING: 40,
  MIN_PLAYERS_FOR_ROUND: 4,
  INVITE_CODE_LENGTH: 8,
  MAX_NAME_LENGTH: 100,
  MAX_DESCRIPTION_LENGTH: 500,
  MAX_ROUNDS_PER_SEASON: 100,
};
